import { useCallback } from 'react';
import { ReportFilterConfig } from '@aidkitorg/types/lib/admin-panel/filters';
import { useReportFilter } from '../contexts/ReportFilterContext';

/**
 * Hook that provides pre-configured props for FilterPanel component
 * that automatically integrates with ReportFilterContext
 */
export const useReportFilterPanel = (instanceId: string) => {
  const {
    filterConfig,
    setFilterConfig,
    availableFields,
    filterRef
  } = useReportFilter();

  const handleFilterChange = useCallback((newConfig: ReportFilterConfig) => {
    setFilterConfig(newConfig);
  }, [setFilterConfig]);

  return {
    // FilterPanel props
    filterPanelProps: {
      value: filterConfig,
      onChange: handleFilterChange,
      availableFields,
      instanceId,
      ref: filterRef
    },
    // Direct access to context values
    filterConfig,
    availableFields,
    filterRef
  };
};